import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';

import {Tabs2Level} from 'src/components/tabs-2-level';
import {USER_TABS} from 'src/constants';

import {Tab} from '@pb/kit-component-tabs-v2';


import {ADMIN_ROLE_SETTINGS_TABS} from './constants';

type Props = {
    userId: number,
    activeSubTab: string,
};

export const UserRoleSettingsTabs = ({userId, activeSubTab}: Props) => {
    const navigate = useNavigate();

    const changeActiveSubTab = useCallback((subTab: string) => {
        navigate(`/profile/user/${userId}/${USER_TABS.ROLE_SETTINGS.name}/${subTab}`);
    }, [userId, navigate]);

    return (
        <Tabs2Level activeTab={activeSubTab} setActiveTab={changeActiveSubTab}>
            <Tab value={ADMIN_ROLE_SETTINGS_TABS.SETTINGS.name} {...ADMIN_ROLE_SETTINGS_TABS.SETTINGS}/>
            <Tab value={ADMIN_ROLE_SETTINGS_TABS.AUDIT_LOG.name} {...ADMIN_ROLE_SETTINGS_TABS.AUDIT_LOG}/>
        </Tabs2Level>
    );
};
